import Jabatan from './Jabatan';

export default Jabatan;
